var _rect, _g, _circle, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddAudio = function SvgAddAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 9.5,
    fill: "#fff",
    stroke: "#1D352A",
    strokeDasharray: "1.57 1.57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add-audio_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1D352A",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.523 13.386v9.556c0 7.24-12.046 7.297-12.046 0v-9.556c0-7.181 12.046-7.181 12.046 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.955 32.093C12.945 31.398 12 24.622 12 18.425c0-1.043 2.396-1.043 2.649-.116.063 4.98.126 11.351 7.82 11.351 7.693 0 7.82-6.37 7.82-11.35.188-.985 2.711-.928 2.711.115 0 6.197-.946 12.973-9.081 13.668v3.475h4.162c1.829 0 1.892 2.432 0 2.432H16.793c-1.766 0-1.703-2.432 0-2.432h4.162v-3.475Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 6,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 5,
    fill: "#1D352A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.25 7h1.5v6h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 10.75v-1.5h6v1.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add-audio_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 8)",
    d: "M0 0h21v30H0z"
  })))));
};
export default SvgAddAudio;